import React from "react";

import { Icon, Tooltip } from "antd";

import styled from "styled-components";

const FltActBtn = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px;

	position: fixed;
	bottom: 32px;
	right: 32px;

	background: #eaf4ec;

	border: 1px solid #fec708;
	box-sizing: border-box;
	box-shadow: 5px 5px 10px #f2e09d3b;
	border-radius: 74px;

	cursor: pointer;

	i {
		font-size: 20px;
		color: #fec708;
	}
`;

const FloatingActionButton = ({ iconType, handleClick, tooltipTitle }) => (
	<Tooltip title={tooltipTitle} placement="left">
		<FltActBtn onClick={handleClick}>
			<Icon type={iconType} />
		</FltActBtn>
	</Tooltip>
);

export default FloatingActionButton;
